import { useUserViewModel } from "../../viewmodels/user/userViewModel";
import DashboardLayout from "../../components/layout/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { getUserId } from "../../utils/authToken";

const UserList = () => {
  const loggedUserId = getUserId();
  const navigate = useNavigate();
  const {
    users,
    loading,
    search,
    setSearch,
    page,
    setPage,
    deleteUser,
  } = useUserViewModel();

  const handleDelete = (id: string) => {
    if (id === loggedUserId) {
      alert("You cannot delete your own account");
      return;
    }

    if (confirm("Delete this user?")) {
      deleteUser(id);
    }
  };

  return (
    <DashboardLayout>
      <div className="p-6">

        {/* BREADCRUMB */}
        <div className="text-sm text-gray-500 mb-3">
          Dashboard / Users
        </div>

        {/* HEADER */}
        <div className="flex justify-between mb-4">
          <h2 className="text-xl font-semibold">Users</h2>

          <button
            onClick={() => navigate("/users/create")}
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            + Create User
          </button>
        </div>

        {/* SEARCH */}
        <input
          placeholder="Search users..."
          className="border px-3 py-2 rounded mb-4 w-full md:w-1/3"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {/* TABLE */}
        <div className="bg-white rounded-xl shadow border border-slate-300 overflow-hidden">

          <div className="overflow-x-auto">

            <table className="min-w-[800px] w-full text-sm text-left border-collapse">

              <thead className="bg-gray-100">

                <tr className="text-left">

                  <th className="p-3 border border-slate-300">
                    Name
                  </th>

                  <th className="p-3 border border-slate-300">
                    Email
                  </th>

                 {/*  <th className="p-3 border border-slate-300">
                    Phone
                  </th> */}

                  <th className="p-3 border border-slate-300 text-center">
                    Actions
                  </th>

                </tr>

              </thead>

              <tbody>

                {loading ? (

                  <tr>

                    <td
                      colSpan={4}
                      className="text-center p-4 border border-slate-300"
                    >
                      Loading...
                    </td>

                  </tr>

                ) : users.length === 0 ? (

                  <tr>

                    <td
                      colSpan={4}
                      className="text-center p-4 text-gray-500 border border-slate-300"
                    >
                      No users found
                    </td>

                  </tr>

                ) : (

                  users.map((u) => (

                    <tr
                      key={u.id}
                      className="hover:bg-gray-50 transition"
                    >

                      {/* NAME */}
                      <td className="p-3 border border-slate-300 font-medium">

                        {u.firstName}
                        {" "}
                        {u.lastName}

                      </td>

                      {/* EMAIL */}
                      <td className="p-3 border border-slate-300">
                        {u.email}
                      </td>

                      {/* PHONE */}
                    {/*   <td className="p-3 border border-slate-300">
                        {u.phoneNumber || "-"}
                      </td> */}

                      {/* ACTIONS */}
                      <td className="p-3 border border-slate-300">

                        <div className="flex gap-2 justify-center">

                          {/* EDIT */}
                          <button
                            onClick={() =>
                              navigate(
                                `/users/edit/${u.id}`
                              )
                            }
                            className="px-3 py-1 text-xs bg-yellow-500 text-white rounded"
                          >
                            Edit
                          </button>

                          {/* DELETE */}
                          <button
                            disabled={
                              u.id === loggedUserId
                            }
                            onClick={() =>
                              handleDelete(u.id)
                            }
                            className={`px-3 py-1 text-xs rounded ${
                              u.id === loggedUserId
                                ? "bg-gray-300 cursor-not-allowed"
                                : "bg-red-600 text-white"
                            }`}
                          >
                            Delete
                          </button>

                        </div>

                      </td>

                    </tr>

                  ))

                )}

              </tbody>

            </table>

          </div>

        </div>

        {/* PAGINATION */}
        <div className="mt-4 flex justify-between">
          <button onClick={() => setPage((prev) => Math.max(1, prev - 1))}>
            Prev
          </button>
          <span>Page {page}</span>
          <button onClick={() => setPage(page + 1)}>
            Next
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default UserList;